import * as actions from "@/AppRedux/actions/admin/hotelProfileConfig/hotelProfileConfigType";
import {
  HotelProfileContentUpdateBatchPayload,
  HotelProfileResponse,
} from "@/AppRedux/actions/admin/hotelProfileConfig/hotelProfileConfigType";

export const hotelProfileContentRequest = (): actions.HotelProfileContentRequest => ({
  type: actions.HOTEL_PROFILE_CONTENT_REQUEST,
});

export const setHotelProfileContentSuccess = (
payload: HotelProfileResponse
): actions.HotelProfileContentSuccess => ({
  type: actions.HOTEL_PROFILE_CONTENT_SUCCESS,
  payload,
});

export const setHotelProfileContentFailure = (
  message: string
): actions.HotelProfileContentFailure => ({
  type: actions.HOTEL_PROFILE_CONTENT_FAILED,
  payload: message,
});

export const requestHotelProfileContentUpdateBatch = (payload: HotelProfileContentUpdateBatchPayload ): actions.HotelProfileContentUpdateBatchRequest => ({
  type: actions.HOTEL_PROFILE_CONTENT_UPDATE_BATCH_REQUEST,
  payload,
});

export const setHotelProfileContentUpdateSuccess = (): actions.HotelProfileContentUpdateSuccess => ({
  type: actions.HOTEL_PROFILE_CONTENT_UPDATE_SUCCESS,
});

export const setHotelProfileContentUpdateFailure = (
  message: string
): actions.HotelProfileContentUpdateFailure => ({
  type: actions.HOTEL_PROFILE_CONTENT_UPDATE_FAILURE,
  payload: message,
});

export const requestHotelProfileGoogleMapUpdate = (payload: any): actions.HotelProfileGoogleMapUpdate => ({
  type: actions.HOTEL_PROFILE_GOOGLE_MAP_UPDATE,
  payload,
});

export const setHotelProfileGoogleMapUpdateSuccess = (): actions.HotelProfileGoogleMapUpdateSuccess => ({
  type: actions.HOTEL_PROFILE_GOOGLE_MAP_UPDATE_SUCCESS,
});

export const setHotelProfileGoogleMapUpdateFailure = (
  message: string
): actions.HotelProfileGoogleMapUpdateFailure => ({
  type: actions.HOTEL_PROFILE_GOOGLE_MAP_UPDATE_FAILURE,
  payload: message,
});

export const requestHotelProfileGalleryUpdate = (payload: any): actions.HotelProfileGalleryUpdate => ({
  type: actions.HOTEL_PROFILE_GALLERY_UPDATE,
  payload,
});

export const setHotelProfileGalleryUpdateSuccess = (): actions.HotelProfileGalleryUpdateSuccess => ({
  type: actions.HOTEL_PROFILE_GALLERY_UPDATE_SUCCESS,
});

export const setHotelProfileGalleryUpdateFailure = (
  message: string
): actions.HotelProfileGalleryUpdateFailure => ({
  type: actions.HOTEL_PROFILE_GALLERY_UPDATE_FAILURE,
  payload: message,
});

export const clearHotelProfileProcess = (): actions.HotelProfileProcessClear => ({
  type: actions.HOTEL_PROFILE_PROCESS_CLEAR,
});

export const processAction = [
  "HOTEL_PROFILE_CONTENT_REQUEST",
  "HOTEL_PROFILE_CONTENT_UPDATE",
  "HOTEL_PROFILE_GOOGLE_MAP_UPDATE",
  "HOTEL_PROFILE_GALLERY_UPDATE",
] as const;
